export default "__VITE_ASSET__BVgdouHn__"